const questions = [
  {
    id: 1,
    question: "She is ___ TV right now.",
    options: ["watch", "watching", "watches"],
    answer: "watching",
    concept: "present_continuous_form",
    skill: "verb_ing_form",
    explanation: "The Present Continuous uses: am / is / are + verb + ing."
  },
  {
    id: 2,
    question: "They ___ playing football at the moment.",
    options: ["is", "are", "do"],
    answer: "are",
    concept: "present_continuous_be",
    skill: "auxiliary_be",
    explanation: "Use 'are' with plural subjects in the Present Continuous."
  },
  {
    id: 3,
    question: "Which sentence is correct?",
    options: [
      "I am study English.",
      "I studying English.",
      "I am studying English."
    ],
    answer: "I am studying English.",
    concept: "present_continuous_structure",
    skill: "sentence_structure",
    explanation: "The correct structure is: subject + am / is / are + verb + ing."
  },
  {
    id: 4,
    question: "He ___ working now.",
    options: ["is", "are", "does"],
    answer: "is",
    concept: "present_continuous_be",
    skill: "auxiliary_be",
    explanation: "Use 'is' with he / she / it in the Present Continuous."
  },
  {
    id: 5,
    question: "Which sentence talks about something happening now?",
    options: [
      "We learn grammar every day.",
      "We are learning grammar now.",
      "We learned grammar yesterday."
    ],
    answer: "We are learning grammar now.",
    concept: "present_continuous_usage",
    skill: "tense_usage",
    explanation: "The Present Continuous is used for actions happening now."
  }
];

export default questions;


